<template>
    <HeaderDropdown>
        <template slot="header">
            <span class="active">Home</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item v-if="currentUser.has_okr" to="/v2/home-okr">
                <span>Home</span>
            </b-dropdown-item>
            <b-dropdown-item :to="`/v2/profile/${currentUser.id}`">
                <span>Home</span>
                <span class="badge-news">{{ $t('new') }}</span>
            </b-dropdown-item>
        </template>
    </HeaderDropdown>
</template>
<script>
import { HeaderDropdown } from '@coreui/vue'

export default {
    props: {
        currentUser: {
            type: Object,
            required: true,
        },
    },
    components: {
        HeaderDropdown,
    },
}
</script>
<style scoped>
.active > .badge-news {
    color: white !important;
}
</style>
